import axios from "axios";

export const POST_IMAGE_SUCCESS = "POST_IMAGE_SUCCESS";
export const POST_IMAGE_FAILURE = "POST_IMAGE_FAILURE";
export const POST_IMAGE_STARTED = "POST_IMAGE_STARTED";

export const DELETE_IMAGE_SUCCESS = "DELETE_IMAGE_SUCCESS";
export const DELETE_IMAGE_FAILURE = "DELETE_IMAGE_FAILURE";
export const DELETE_IMAGE_STARTED = "DELETE_IMAGE_STARTED";

const POST_SUPPLEMENTAL_DOCUMENT_SUCCESS = "POST_SUPPLEMENTAL_DOCUMENT_SUCCESS";
const DELETE_SUPPLEMENTAL_DOCUMENT_SUCCESS =
  "DELETE_SUPPLEMENTAL_DOCUMENT_SUCCESS";

export const postImage = (postData) => {
  return (dispatch) => {
    dispatch(postImageStarted());

    axios
      .post(postData.url, postData.imageData)
      .then(({ data }) => {
        dispatch(
          postImageSuccess({
            image: data[postData.responseKey],
            type: "voidedCheck",
          })
        );
      })
      .catch((err) => {
        dispatch(postImageFailure(err.response.data.ui_message));
      });
  };
};

export const postSupplementalDocument = (postData) => {
  return (dispatch) => {
    dispatch(postImageStarted());

    axios
      .post(`/images/supplemental-document/`, postData.imageData)
      .then(({ data }) => {
        dispatch({
          type: POST_SUPPLEMENTAL_DOCUMENT_SUCCESS,
          payload: {
            key: postData.imageKey,
            image: data,
            coRenter: postData.coRenter,
            responseKey: postData.responseKey,
          },
        });
        // dispatch(
        //   postImageSuccess({
        //     image: data[postData.responseKey],
        //     type: "voidedCheck",
        //   })
        // );
      })
      .catch((err) => {
        dispatch(postImageFailure(err.response.data.ui_message));
      });
  };
};

export const deleteSupplementalDocument = (postData) => {
  return (dispatch) => {
    dispatch(deleteImageStarted());

    axios
      .delete(`/images/supplemental-document/${postData.filename}/`)
      .then(({ data }) => {
        dispatch({
          type: DELETE_SUPPLEMENTAL_DOCUMENT_SUCCESS,
          payload: {
            key: postData.imageKey,
            filename: postData.filename,
            coRenter: postData.coRenter,
            keyName: postData.keyName,
          },
        });
      })
      .catch((err) => {
        dispatch(deleteImageFailure(err.response.data.ui_message));
      });
  };
};

const postImageStarted = () => ({ type: POST_IMAGE_STARTED });

const postImageSuccess = (image) => ({
  type: POST_IMAGE_SUCCESS,
  payload: image,
});

const postImageFailure = (error) => ({
  type: POST_IMAGE_FAILURE,
  payload: error,
});

export const deleteImage = (postData) => {
  return (dispatch) => {
    dispatch(deleteImageStarted());

    axios
      .delete(postData.url)
      .then(({ data }) => {
        dispatch(
          deleteImageSuccess({
            type: "voidedCheck",
          })
        );
      })
      .catch((err) => {
        dispatch(deleteImageFailure(err.response.data.ui_message));
      });
  };
};

const deleteImageStarted = () => ({ type: DELETE_IMAGE_STARTED });

const deleteImageFailure = (error) => ({
  type: DELETE_IMAGE_FAILURE,
  payload: error,
});

const deleteImageSuccess = (image) => ({
  type: DELETE_IMAGE_SUCCESS,
  payload: image,
});

function contractImagesReducer(state, action) {
  switch (action.type) {
    case POST_IMAGE_STARTED:
      return {
        ...state,
        loading: true,
      };
    case POST_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_IMAGE_SUCCESS:
      return {
        // loading: false,
        ...state,
        loading: false,
        [action.payload.type]: action.payload.image,
      };
    case DELETE_IMAGE_STARTED:
      return {
        ...state,
        loading: true,
      };
    case DELETE_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload.type]: null,
      };
    case POST_SUPPLEMENTAL_DOCUMENT_SUCCESS:
      let doc = { ...state[action.payload.key] };

      if (action.payload.coRenter) {
        if (!state.coRenter) return { ...state, loading: false };

        doc = state.coRenter[action.payload.responseKey];

        if (!doc) return { ...state, loading: false };

        if (doc.supplemental_documents) {
          doc.supplemental_documents.push(action.payload.image);
        } else {
          doc.supplemental_documents = [action.payload.image];
        }

        return {
          ...state,
          loading: false,
          coRenter: {
            ...state.coRenter,
            [action.payload.responseKey]: doc,
          },
        };
      }

      if (!doc) return { ...state, loading: false };

      if (doc.supplemental_documents) {
        doc.supplemental_documents.push(action.payload.image);
      } else {
        doc.supplemental_documents = [action.payload.image];
      }

      return {
        ...state,
        loading: false,
        [action.payload.key]: doc,
      };
    case DELETE_SUPPLEMENTAL_DOCUMENT_SUCCESS:
      let d = null;

      if (action.payload.coRenter) {
        if (!state.coRenter) return { ...state, loading: false };

        d = state.coRenter[action.payload.keyName];

        if (!d) return { ...state, loading: false };

        d.supplemental_documents = d.supplemental_documents.filter(
          (f) => f.filename !== action.payload.filename
        );

        return {
          ...state,
          loading: false,
          coRenter: {
            ...state.coRenter,
            [action.payload.keyName]: d,
          },
        };
      } else {
        d = { ...state[action.payload.key] };
      }
      if (!d) return { ...state, loading: false };

      d.supplemental_documents = d.supplemental_documents.filter(
        (f) => f.filename !== action.payload.filename
      );

      return {
        ...state,
        loading: false,
        [action.payload.key]: d,
      };
    default:
      return state;
  }

  return state;
}

export default contractImagesReducer;
